﻿/**
 * Memorix Workbench  Ink-based Terminal UI
 *
 * Thin redirect to the new Ink TUI in ./tui/
 * Kept for backward-compat: `import { startWorkbench } from './workbench.js'`
 */

export { startWorkbench } from './tui/index.js';
